export default __webpack_public_path__ + "static/media/psypack.3498c1d8.svg";